import React from 'react';
import { useTranslation } from 'react-i18next';

interface EditableNotesSectionProps {
  data: any;
  onUpdate: (field: any, value: string) => void;
  accentColor: string;
}

/**
 * Section éditable pour les notes internes
 * ✅ Simplifié: utilise internalNotes (aligné sur Prisma)
 * Note: Le titre et les conditions générales sont dans EditableQuoteExtendedFields
 */
export const EditableNotesSection: React.FC<EditableNotesSectionProps> = ({
  data,
  onUpdate,
  accentColor: _accentColor,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      {/* Notes internes (non visibles sur le PDF client) */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t('templates.common.internalNotes')}
        </label>
        <textarea
          value={data.internalNotes || ''}
          onChange={(e) => onUpdate('internalNotes', e.target.value)}
          className="w-full px-3 py-2.5 bg-white/40 backdrop-blur-sm border border-white/40 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 focus:bg-white/60 transition-all duration-300 resize-y min-h-[100px]"
          placeholder={t('templates.common.internalNotesPlaceholder')}
        />
        <p className="text-xs text-gray-500 mt-2">
          {t('templates.common.internalNotesHint')}
        </p>
      </div>
    </div>
  );
};
